import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pages = [];

  // Générer dynamiquement les numéros de pages
  for (let i = 1; i <= totalPages; i++) {
    pages.push(
      <button
        key={i}
        onClick={() => onPageChange(i)}
        className={`w-10 h-10 flex items-center rounded-full justify-center font-medium ${
          currentPage === i ? "bg-purple-1 text-white" : ""
        }`}
      >
        {i}
      </button>
    );
  }

  return (
    <div className="flex justify-center pt-12">
      <div className="flex items-center space-x-2">
        {/* Bouton précédent */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="p-3 rounded-full bg-purple-200 disabled:opacity-50"
        >
          <ChevronLeftIcon className="w-5 h-5 text-purple-1" />
        </button>

        {/* Numéros de page */}
        <div className="flex space-x-1">{pages}</div>

        {/* Bouton suivant */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="p-3 rounded-full bg-purple-200 disabled:opacity-50"
        >
          <ChevronRightIcon className="w-5 h-5 text-purple-1" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
